import { auth } from "@/lib/auth";
import { NextResponse } from "next/server";

export default auth((req) => {
  const { pathname } = req.nextUrl;
  const role = req.auth?.user?.role;

  if (pathname.startsWith("/admin") && role !== "ADMIN") {
    return NextResponse.redirect(new URL("/connexion", req.nextUrl));
  }

  if (pathname.startsWith("/dashboard") && role !== "PHARMACY") {
    return NextResponse.redirect(new URL("/connexion", req.nextUrl));
  }
});

export const config = {
  matcher: ["/admin/:path*", "/dashboard/:path*"],
};
